<template>
    <div>
        <svg v-if="engagement === 'adopted'" width="16" height="16" viewBox="0 0 16 16"><use xlink:href="#icon--engage-badge"></use></svg>
        <svg v-else-if="testIfCircle(engagement)" :class="getColorClass(engagement)" width="16" height="16" viewBox="0 0 16 16"><use xlink:href="#icon--engage-circle"></use></svg>
        <svg v-else width="16" height="4" viewBox="0 0 16 4"><use xlink:href="#icon--engage-line"></use></svg>
        <span class="sr-only">{{ engagement}}</span>
    </div>
</template>

<script setup>
    import {getColorClass} from '../reusables/GetColorClass.js'
    
    defineProps({
        engagement: String
    })

    const engageCircles = ['engaged', 'declined', 'acknowledged']
    function testIfCircle(engagement){
        return engageCircles.includes(engagement)
    }
    
</script>

<style scoped>
.has-gray-light-color {
    color: #BFBFBF;
}
</style>